import { useState, useEffect, useContext } from 'react';

import { Link, withRouter } from 'react-router-dom';
import LogoCelciusColor from '../../assets/img/logos/LogoCelciusColor.svg';
import LogoBasic from '../../assets/img/logos/Celsius.svg';
import UserIcon from '~/assets/img/User.svg';
import IconSidebar from '~/assets/img/sidebar/MenuMobile.svg';
import CloseIconSidebar from '~/assets/img/sidebar/Close.svg';
import { MenuMobile } from '~/components/MenuMobile';
import { MenuUserMobile } from '../MenuUserMobile';
import { getUserProfile } from '~/helpers/userProfile';
import {
  RelativeWrapper,
  CloseWrapper,
  ModalNavItems,
  ActionableWrapper,
  Icon,
  Topbar,
  Wrapper,
  TopBarRightContainer,
} from './styles';
import { SearchNewIcon, SpringerLogo } from '~/icons';
import { getUserClientId } from '~/helpers/getClientsHelper';
import { GlobalSearch } from '../Header/GlobalSearch';
import { ChangeProfile } from '../Header';
import SelectPlataformContext from '~/contexts/selectPlataform';

const MobileNavbar = ({ history }) => {
  const [isModalNavItemsOpen, setIsModalNavItemsOpen] = useState(false);
  const [isModalUserOpen, setIsModalUserOpen] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [profile] = useState(getUserProfile);
  const [clientIds, setClientIds] = useState<number[] | null>(null);
  const { selectPlataform } = useContext(SelectPlataformContext);

  const isNewOverview = history?.location.pathname === '/nova-visao-geral';

  const celsiusAdmin = clientIds && (clientIds?.filter((item) => (item !== 157 && item !== 158)).length !== 0 || profile.permissions.isAdminSistema);

  /* 157 - Atacadão 158 - Carrier */
  const hasSpringerLogo = !profile.permissions.isAdminSistema
  && clientIds
  && clientIds?.filter((item) => (item !== 157 && item !== 158)).length === 0;

  const selectedRemoteControl = selectPlataform === '/controle-inteligente';

  useEffect(() => {
    if (!isModalUserOpen && !isModalNavItemsOpen) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isModalUserOpen, isModalNavItemsOpen]);

  useEffect(() => {
    getUserClientId({ profile, setClientIds });
  }, []);

  return (
    <Wrapper>
      <Topbar isNewOverview={isNewOverview}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {(isOpenSearch && celsiusAdmin) ? (
            <img src={LogoBasic} alt="basicLogo " />
          ) : (
            <ActionableWrapper onClick={() => setIsModalNavItemsOpen(true)}>
              <Icon src={IconSidebar} alt="user-icon" />
            </ActionableWrapper>
          )}
          {!isOpenSearch && profile.permissions.isPersonaII && <ChangeProfile isMobile />}
        </div>
        {!isOpenSearch && (
          <Link to="/visao-geral">
            {(celsiusAdmin || profile.permissions.isPersonaII) && <img src={LogoCelciusColor} alt="logoCelcius " />}
            {hasSpringerLogo && <SpringerLogo color="black" />}
          </Link>
        )}
        {isOpenSearch && !selectedRemoteControl && (
          <GlobalSearch isMobile setOpenSearch={setIsOpenSearch} />
        )}
        <TopBarRightContainer>
          {!selectedRemoteControl && (
            <div onMouseOver={() => {}} onFocus={() => {}} onClick={() => setIsOpenSearch(!isOpenSearch)}>
              <SearchNewIcon />
            </div>
          )}
          <ActionableWrapper onClick={() => setIsModalUserOpen(true)}>
            <Icon src={UserIcon} alt="user-icon" />
          </ActionableWrapper>
        </TopBarRightContainer>
      </Topbar>
      {(isModalNavItemsOpen || isModalUserOpen) && (
        <ModalNavItems>
          <RelativeWrapper>
            <CloseWrapper
              onClick={() => (isModalNavItemsOpen ? setIsModalNavItemsOpen(false) : setIsModalUserOpen(false))}
            >
              <Icon src={CloseIconSidebar} alt="close-sidebar-icon" />
            </CloseWrapper>
            {isModalNavItemsOpen ? (
              <MenuMobile setIsModalNavItemsOpen={setIsModalNavItemsOpen} />
            ) : (
              <MenuUserMobile setIsModalUserOpen={setIsModalUserOpen} />
            )}
          </RelativeWrapper>
        </ModalNavItems>
      )}
    </Wrapper>
  );
};

const MobileNavbarWrapper = withRouter(MobileNavbar);

export { MobileNavbarWrapper as MobileNavbar };
